import classNames from 'classnames';
import { ReactNode } from 'react';

interface Props {
  title: string;
  text: ReactNode;
  interval?: number;
  clasName?: string;
  direction?: 'row' | 'col';
}
export function InfoItem(props: Props) {
  const { title, text, clasName, interval = 1, direction = 'col' } = props;
  return (
    <div
      className={classNames(
        'flex',
        {
          'flex-col': direction === 'col',
          'flex-row': direction === 'row',
          'justify-between': direction === 'row'
        },
        clasName
      )}
    >
      <div className={`text-sm text-gray-600  mb-${direction === 'col' ? interval : 0}`}>{title}</div>
      <div className="text-sm font-medium text-gray-900 break-all">{text}</div>
    </div>
  );
}
